import clsx from 'clsx';
import styles from './Skeleton.module.css';

export interface SkeletonProps {
  /** Inline width (number = px, string = any CSS value). Defaults to 100%. */
  width?: number | string;
  /** Inline height. Defaults to 1em for line variant. */
  height?: number | string;
  /** Shape variant. `line` for text, `block` for solid block, `circle` for avatars. */
  variant?: 'line' | 'block' | 'circle';
  /** Use the radius scale ('sm' | 'md' | 'lg' | 'full'). */
  radius?: 'sm' | 'md' | 'lg' | 'full';
  className?: string;
}

/**
 * Pulsing skeleton placeholder. Use while data is loading to convey shape
 * (don't use full-page spinners — they steal trust).
 */
export function Skeleton({
  width,
  height,
  variant = 'line',
  radius,
  className,
}: SkeletonProps) {
  const style: React.CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
  };
  return (
    <span
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={clsx(
        styles.skeleton,
        styles[`variant_${variant}`],
        radius && styles[`radius_${radius}`],
        className,
      )}
      style={style}
    />
  );
}
